var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPosition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19316 13.4053C7.2133 13.4165 7.22913 13.4252 7.24034 13.4313L7.25895 13.4413C7.40753 13.5198 7.59184 13.5192 7.74056 13.4415L7.75966 13.4313C7.77087 13.4252 7.7867 13.4165 7.80684 13.4053C7.84711 13.3828 7.90465 13.3501 7.977 13.3072C8.12164 13.2214 8.32583 13.0949 8.56974 12.929C9.05673 12.5977 9.7065 12.1061 10.3577 11.464C11.6538 10.1861 13 8.26599 13 5.79667C13 2.8714 10.5376 0.5 7.5 0.5C4.46243 0.5 2 2.8714 2 5.79667C2 8.26599 3.34622 10.1861 4.6423 11.464C5.2935 12.1061 5.94327 12.5977 6.43026 12.929C6.67417 13.0949 6.87836 13.2214 7.023 13.3072C7.09535 13.3501 7.15289 13.3828 7.19316 13.4053ZM7.5 7.72274C8.60457 7.72274 9.5 6.86041 9.5 5.79667C9.5 4.73294 8.60457 3.87061 7.5 3.87061C6.39543 3.87061 5.5 4.73294 5.5 5.79667C5.5 6.86041 6.39543 7.72274 7.5 7.72274Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPosition);
export default __webpack_public_path__ + "static/media/Icon_Position.69245295f5168b5aad2277a2d657cb6f.svg";
export { ForwardRef as ReactComponent };